module.exports = __webpack_public_path__ + "static/img/logo-jsq.b328626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-jsq.png
// module id = dP7V
// module chunks = 1